var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shared-hotel-adv"},[_c('nav-bar',{attrs:{"fontColor":"#333","titleText":_vm.$route.query.main_title,"fontSize":"18px"},on:{"goBack":_vm.goBack}}),_c('img',{attrs:{"src":_vm.$route.query.img_url,"alt":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }